module.exports = {

    development: {
        // local
//      backend_url: 'http://localhost:4000/',
//      frontend_url: 'http://localhost:8080',
//      viewer_url: 'https://cert.digitalautomations.it?code=',
        // dev
        backend_url: 'https://api.aednotarify.com/',
        frontend_url: 'https://aednotarify.com',
        viewer_url: 'https://cert.aednotarify.com?code=',
        rows_per_page: 25,
        gui: {
            color     : '#060606',
            icon      : 'default.png',
            app_label : 'Notarizer',
        },
    },

    production: {
        backend_url: 'https://api.aednotarify.com/',
        frontend_url: 'https://aednotarify.com',
        viewer_url: 'https://cert.aednotarify.com?code=',
        rows_per_page: 25,
        gui: {
            color     : '#060606',
            icon      : 'default.png',
            app_label : 'Notarizer',
        },
    },

};
